module.exports = __webpack_public_path__ + "img/1460684049.7fb0c79c.jpg";